import { useSettingIds } from './setting-row.tsx'
import styles from './toggle.module.css'

interface ToggleProps {
  readonly checked: boolean
  readonly onChange: (checked: boolean) => void
}

/** A switch. Enter, Space, and a gamepad confirm all activate the button. */
export function Toggle({ checked, onChange }: ToggleProps) {
  const { id, describedBy } = useSettingIds()
  return (
    <button
      id={id}
      type="button"
      role="switch"
      class={styles.switch}
      aria-checked={checked}
      aria-describedby={describedBy}
      data-on={checked || undefined}
      onClick={() => {
        onChange(!checked)
      }}
    >
      <span class={styles.thumb} />
    </button>
  )
}
